import { SimpleGrid } from '@chakra-ui/react';
import React from 'react';

export interface LayoutAdminGridProps {
  children: React.ReactNode;
  columns?: number | Record<string, number>;
  gap?: number | Record<string, number>;
  dataTestId?: string;
}

export const LayoutAdminGrid: React.FC<LayoutAdminGridProps> = ({
  children,
  columns = {
    base: 1,
    md: 2,
    lg: 3,
  },
  gap = {
    base: 3,
    md: 4,
    lg: 4,
    xl: 5,
    '2xl': 6,
  },
  dataTestId = 'layout-admin-grid',
}) => (
  <SimpleGrid
    columns={columns}
    gap={gap}
    autoRows="1fr"
    pb={6}
    overflow="auto"
    data-testid={dataTestId}
  >
    {children}
  </SimpleGrid>
);

export default LayoutAdminGrid;
